/**
 * Shared image lightbox — singleton modal appended to <body> on first
 * open. Any block can request it via `window.ckLightbox.open(urls, i)`.
 *
 * Markup is owned here; styling lives in
 * `assets/src/sass/components/_lightbox.scss` (class `.ck-lightbox`).
 * Keyboard nav (←, →, Esc) is bound once at the document level and
 * no-ops while the modal is hidden.
 */

jQuery(function ($) {
    let api = null;

    function build() {
        const $modal = $(
            '<div class="ck-lightbox" role="dialog" aria-modal="true" aria-label="Image gallery" hidden>' +
                '<button type="button" class="ck-lightbox__close" aria-label="Close">&times;</button>' +
                '<button type="button" class="ck-lightbox__nav ck-lightbox__nav--prev" aria-label="Previous">' +
                    '<svg width="16" height="28" viewBox="0 0 16 28" fill="none" aria-hidden="true"><path d="M14 2L2 14l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</button>' +
                '<button type="button" class="ck-lightbox__nav ck-lightbox__nav--next" aria-label="Next">' +
                    '<svg width="16" height="28" viewBox="0 0 16 28" fill="none" aria-hidden="true"><path d="M2 2l12 12L2 26" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</button>' +
                '<img class="ck-lightbox__image" src="" alt="">' +
            '</div>'
        );
        $('body').append( $modal );

        const state = {
            $modal,
            $image: $modal.find('.ck-lightbox__image'),
            urls: [],
            index: 0,
        };

        function render() {
            state.$image.attr( 'src', state.urls[ state.index ] || '' );
        }

        function open( urls, startIndex ) {
            if ( ! Array.isArray( urls ) || ! urls.length ) return;
            state.urls = urls;
            state.index = Math.max( 0, Math.min( startIndex || 0, urls.length - 1 ) );
            render();
            state.$modal.prop( 'hidden', false );
            $('html').addClass( 'is-ck-lightbox-open' );
        }

        function close() {
            state.$modal.prop( 'hidden', true );
            $('html').removeClass( 'is-ck-lightbox-open' );
            state.$image.attr( 'src', '' );
        }

        function step( dir ) {
            if ( ! state.urls.length ) return;
            state.index = ( state.index + dir + state.urls.length ) % state.urls.length;
            render();
        }

        state.$modal.on( 'click', function ( e ) {
            // Backdrop click (anything not the image, nav, or close) closes.
            if ( $( e.target ).is( state.$image ) ) return;
            if ( $( e.target ).closest( '.ck-lightbox__nav, .ck-lightbox__close' ).length ) return;
            close();
        } );
        state.$modal.find( '.ck-lightbox__close' ).on( 'click', close );
        state.$modal.find( '.ck-lightbox__nav--prev' ).on( 'click', function () { step( -1 ); } );
        state.$modal.find( '.ck-lightbox__nav--next' ).on( 'click', function () { step(  1 ); } );

        $(document).on( 'keydown', function ( e ) {
            if ( state.$modal.prop( 'hidden' ) ) return;
            if ( e.key === 'Escape' ) close();
            else if ( e.key === 'ArrowLeft' )  step( -1 );
            else if ( e.key === 'ArrowRight' ) step(  1 );
        } );

        return { open, close };
    }

    window.ckLightbox = {
        open: function ( urls, index ) {
            if ( ! api ) api = build();
            api.open( urls, index );
        },
        close: function () {
            if ( api ) api.close();
        },
    };
});